import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SortPathLookupProtocolsCommand {
  dragIndex: number;
  hoverIndex: number;
}

export const sortPathLookupProtocols: GraphCommandFactory<
  SortPathLookupProtocolsCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    const { presetDraft } = draft.pathlookup;
    // Fixed noUncheckedIndexedAccess NIM-19408
    const draggedProtocol = presetDraft.edges[command.dragIndex]!;
    presetDraft.edges.splice(command.dragIndex, 1);
    presetDraft.edges.splice(command.hoverIndex, 0, draggedProtocol);
  });
};
